import React, { useState, useEffect } from 'react';
import {
    Box, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TablePagination, Paper, Pagination, CircularProgress,
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button
} from '@mui/material';
import axios from 'axios';
import * as common from '../../../commons/common';
import SearchArea from '../../../components/managerPage/searchArea';

// 경희대 pdf 양식1 - 평화의전당 자체 안전검사표
const CheckReport1 = () => {
    const today = new Date().toISOString().substring(0, 10);
    const [facilityTypes, setFacilityTypes] = useState([]);
    const [list, setList] = useState([]);

    const [errors, setErrors] = useState({});
    const [isDownloading, setIsDownloading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [note, setNote] = useState('');

    const [searchParams, setSearchParams] = useState({
        facilityType: '',
        facilityNm: '',
        startDt: today,
        endDt: today,
        pageSize: '',
        page: '',
    });

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalElements, setTotalElements] = useState(0);

    const hostname = window.location.hostname;
    const isKhuDomain = hostname === 'khu.unicheck.co.kr';

    useEffect(() => {
        getFacilityType()
    }, [])

    useEffect(() => {
        getCheckList();
    }, [page, rowsPerPage]);

    // 시설유형 리스트
    const getFacilityType = async () => {
        const url = `${common.getApiUrl()}/facility-type`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (response.data && Array.isArray(response.data)) {
                const fetchedItems = response.data.map((type) => ({
                    value: type.facilityTypeId,
                    label: type.facilityTypeNm,
                }));
                fetchedItems.unshift({ value: ' ', label: '선택' });
                setFacilityTypes(fetchedItems);
            }
        } catch (error) {
            console.error('데이터를 가져오는 데 실패했습니다:', error);
        }
    };

    const handleSearchParamChange = (name, value) => {
        setSearchParams({
            ...searchParams,
            [name]: value
        });
    };

    const handleSearchSubmit = () => {
        if (!searchParams.facilityType || searchParams.facilityType === ' ') {
            setErrors({
                facilityType: '시설유형을 선택해주세요'
            });
            return;
        }
        setErrors({});
        setPage(1);
        getCheckList();
    };

    // 점검 기록 리스트 조회(시설유형별)
    const getCheckList = async () => {
        const url = `${common.getApiUrl()}/pdf/facilityType-checkList`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params: {
                    facilityTypeId: searchParams.facilityType,
                    startCheckTime: searchParams.startDt,
                    endCheckTime: searchParams.endDt,
                    pageSize: rowsPerPage,
                    page: page
                }
            });

            setList(response.data.content);
            setTotalElements(response.data.totalElements);

        } catch (error) {
            console.error('데이터를 가져오는 데 실패했습니다:', error);
        }
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setNote('');
    };

    const handlePdfDownload = async () => {
        setIsDownloading(true);
        const url = `${common.getApiUrl()}/pdf/facilityType-checkRslt`;
        const token = localStorage.getItem('access_token');

        // note를 줄바꿈 기준으로 나누고 | 구분자로 합치기
        const formattedNote = note.split('\n')
            .filter(line => line.trim() !== '')
            .join('|');

        const params = {
            facilityTypeId: searchParams.facilityType,
            startCheckTime: searchParams.startDt,
            endCheckTime: searchParams.endDt,
            note: formattedNote
        };

        const fileName = isKhuDomain ? '평화의전당 자체 안전검사표.pdf' : '공중화장실 점검표.pdf';

        try {
            const response = await axios.post(url, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);
            handleCloseDialog();

        } catch (error) {
            console.error('PDF 다운로드 실패:', error);
        } finally {
            setIsDownloading(false);
        }
    };

    const handleRightBtnClick = () => {
        handleOpenDialog();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setRowsPerPage(newSize);
        setPage(1);
    };

    return (
        <>
            <Box sx={{ width: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
                <SearchArea
                    searchValues={{ facilityType: searchParams.facilityType, facilityNm: searchParams.facilityNm, startDt: searchParams.startDt, endDt: searchParams.endDt }}
                    handleSearchChanges={(name, value) => { handleSearchParamChange(name, value); }}
                    fields={[
                        {
                            fieldnm: '시설유형',
                            name: 'facilityType',
                            type: 'select',
                            options: facilityTypes,
                            error: errors.facilityType
                        },
                        {
                            fieldnm: '점검일',
                            name: 'startDt',
                            type: 'calendar',
                        },
                        {
                            fieldnm: '~',
                            name: 'endDt',
                            type: 'calendar',
                        }
                    ]}
                    onSearchClick={handleSearchSubmit}
                    showRightButton="true"
                    rightBtnText={isDownloading ? <CircularProgress size={24} color="inherit" /> : "보고서 다운로드"}
                    rightBtnbgcolor={list.length > 0 ? "var(--sub-darkblue-color)" : "var(--sub-darkgray-color)"}
                    onRightBtnClick={handleRightBtnClick}
                    rightBtnDisabled={list.length === 0 || isDownloading}
                />
                <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '10px', padding: '15px 10px' }}>
                    <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#F2F2F2' }}>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>시설유형</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>시설명</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>점검자</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>점검일</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.length > 0 ? (
                                    list.map((item, index) => (
                                        <TableRow key={index} sx={{ height: '52px' }}>
                                            <TableCell align="center" sx={{ padding: '4px' }}>{item.facilityTypeNm}</TableCell>
                                            <TableCell align="center" sx={{ padding: '4px' }}>{item.facilityNm}</TableCell>
                                            <TableCell align="center" sx={{ padding: '4px' }}>{item.checkerNm}</TableCell>
                                            <TableCell align="center" sx={{ padding: '4px' }}>{item.checkTime}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow sx={{ height: '52px' }}>
                                        <TableCell colSpan={4} align="center">
                                            검색된 데이터가 없습니다.
                                        </TableCell>
                                    </TableRow>
                                )}
                                {Array.from({ length: Math.max(rowsPerPage - (list.length || 1), 0) }).map((_, index) => (
                                    <TableRow key={`empty-row-${index}`} sx={{ height: '54px' }}>
                                        <TableCell colSpan={4} sx={{ padding: '8px' }} />
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 2, }}>
                        <Box>
                            <Pagination
                                count={Math.ceil(totalElements / rowsPerPage)}
                                page={page}
                                onChange={(event, newPage) => handleChangePage(event, newPage)}
                                showFirstButton
                                showLastButton
                            />
                        </Box>
                        <Box sx={{ position: 'absolute', top: 5, left: 0 }}>
                            <TablePagination
                                labelDisplayedRows={() => ''}
                                component="div"
                                page={page - 1}
                                count={totalElements}
                                rowsPerPageOptions={[10, 25, 50]}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                ActionsComponent={() => null}
                                onPageChange={() => null}
                            />
                        </Box>
                    </Box>
                </Paper>
            </Box>
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle>점검결과 입력</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="점검결과"
                        fullWidth
                        multiline
                        rows={4}
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                    />
                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary', }}>
                        * 엔터키로 구분된 리스트 형식으로 출력됩니다.
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>취소</Button>
                    <Button onClick={handlePdfDownload} disabled={isDownloading}>
                        {isDownloading ? <CircularProgress size={24} /> : "다운로드"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default CheckReport1;